import { z } from 'zod';
import { WeeklyScheduleSchema } from './availability.js';
/**
 * `businesses/{businessId}/staff/{staffId}` — a bookable person (doc 09 §5.1).
 * Owner-managed configuration, same posture as `services`: no server-side
 * invariant, edited directly through the data-access adapter. Appointments are
 * booked against a staff member; a business with no active staff falls back to
 * business-wide capacity (doc 09 D3).
 */
export const StaffMemberSchema = z.object({
    /** Display name, spoken by the AI to callers — first name recommended (doc 09 §13 GDPR). */
    name: z.string().min(1).max(80),
    active: z.boolean().default(true),
    /** Manual ordering; ALSO the auto-assignment priority when a caller has no
     * preference — first eligible+free from the top wins (doc 09 D5). */
    sortOrder: z.number().int().default(0),
    /** Services this person performs; empty = performs ALL services (doc 09 D6). */
    serviceIds: z.array(z.string()).default([]),
    /**
     * Personal weekly schedule. `null` = inherit the business's fallback hours
     * (doc 09 D2). When set, it REPLACES business hours for this person — no
     * intersection; multiple intervals per day = split shifts.
     */
    schedule: WeeklyScheduleSchema.nullable().default(null),
});
export const StaffMemberWithIdSchema = StaffMemberSchema.extend({ id: z.string() });
//# sourceMappingURL=staff.js.map